var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "record-wrapper",
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _vm.recordBlob
        ? _c("img", {
            staticClass: "preview-container record-blob",
            attrs: { src: _vm.recordBlob }
          })
        : _c(
            "div",
            { staticClass: "preview-container" },
            [
              _c("font-awesome-icon", {
                attrs: { icon: "fa-solid fa-eye-slash center", size: "2x" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "no-preview" }, [
                _vm._v(_vm._s("No preview" + _vm.getDocumentType))
              ])
            ],
            1
          ),
      _vm._v(" "),
      _c("div", { staticStyle: { margin: "12px 8px" } }, [
        _c("div", { staticClass: "record-name single-line-text" }, [
          _vm._v(_vm._s(_vm.title))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "record-date" }, [_vm._v(_vm._s(_vm.date))])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }